import { render, staticRenderFns } from "./UploadStatusButton.vue?vue&type=template&id=6290ac3f"
import script from "./UploadStatusButton.vue?vue&type=script&lang=ts"
export * from "./UploadStatusButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports